<template>
    <v-tooltip location="bottom" :disabled="!hasTooltip">
        <template #activator="{ props }">
            <v-btn-icon
                class="align-end"
                v-bind="props"
                @click="onAuditCheckOkButtonClick()"
                data-cy="AuditCheckOkButton_Button_Click"
            >
                <v-icon class="pb-1" color="primary" size="x-large"> $check </v-icon>
            </v-btn-icon>
        </template>
        <span data-cy="AuditCheckOkButton_Tooltip">{{ tooltipMessage }}</span>
    </v-tooltip>
</template>

<script lang="ts">
import { Component, toNative, Prop, Vue } from "vue-facing-decorator";

import { AuditCheckBankKey } from "@/types/auditCheck.types"

/**
 * Component for displaying a checked state for audit check items.
 */
@Component({})
export class AuditCheckOkButton extends Vue {
    /**
     * Type of audit check. Used to determine the tooltip message.
     * Optional: if not provided, the tooltip is not displayed.
     */
    @Prop({default: null, required: false}) readonly auditCheckType: "Bank" | null;

    /**
     * The accounting period id. Mandatory
     */
    @Prop({ required: true }) readonly accountingPeriodId: string;

    /**
     * The company id. Mandatory
     */
    @Prop({ required: true }) readonly companyId: any;

    /**
     * Indicates if the tooltip should be displayed.
     */
    hasTooltip = true;

    /**
     * Gets the tooltip message based on the audit check type.
     */
    get tooltipMessage(): string {
        switch (this.auditCheckType) {
            case "Bank":
                this.hasTooltip = true;
                return "Pas d'écart de trésorerie - accéder aux rapprochements bancaires";
            default:
                this.hasTooltip = false;
                return "";
        }
    }

    /**
     * Handles the click event on the button.
     */
    onAuditCheckOkButtonClick(): void {
        this.navigateToReconciliation();
    }

    /**
     * Navigates to the bank reconciliation page.
     */
    navigateToReconciliation(): void {
        this.$router.push({
            name: "bank-reconciliation",
            params: {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                acKey: AuditCheckBankKey.BankReconciliation,
            },
        });
    }
}

export default toNative(AuditCheckOkButton);
</script>
